(function () {
    const pages = {
        init: function init() {
            pages.controls();
            pages.mainHeight();
        },
        controls: function controls() {
            $(window).resize(function () {
                pages.mainHeight();
            });
        },
        mainHeight: function mainHeight() {
            let header = $('header').outerHeight(true);
            let footer = $('footer').outerHeight(true);
            $('main.content').css('min-height', `calc(100vh - ${header}px - ${footer}px )`);
        },
    };
    UX.pages = pages;
    document.addEventListener('DOMContentLoaded', function () {
        if (document.querySelector('main.content')) {
            UX.pages.init();
        }
    });
})();
